<template>
  <div class="d-flex align-items-center text-white">
    <v-btn
      dark
      width="24"
      height="24"
      :disabled="currentPage === 1"
      elevation="0"
      icon
      @click.stop="currentPage--"
      class="text-white"
      v-if="pagesAmount > 1"
    >
      <v-icon dark>mdi-chevron-left</v-icon>
    </v-btn>
    <template v-if="currentPage > 3">
      <v-btn
        dark
        elevation="0"
        icon
        text
        class="text-white"
        :disabled="currentPage === 1"
        @click.stop="currentPage = 1"
      >
        {{ 1 }}
      </v-btn>
    </template>
    <template v-if="pagesAmount > 5 && currentPage > 4">
      <span>...</span>
    </template>
    <span v-if="pagesAmount > 1">
      <span v-for="i in pagesList" :key="i">
        <template v-if="i <= pagesAmount">
          <v-btn
            dark
            elevation="0"
            :icon="i < 100"
            :rounded="i > 100"
            text
            class="text-white"
            :disabled="currentPage === i"
            @click.stop="currentPage = i"
          >
            {{ i }}
          </v-btn>
        </template>
      </span>
    </span>
    <template v-if="pagesAmount > 5 && currentPage < pagesAmount - 2">
      <span>...</span>
    </template>
    <template v-if="pagesAmount > 5 && currentPage < pagesAmount - 2">
      <v-btn
        dark
        elevation="0"
        :icon="pagesAmount < 100"
        :rounded="pagesAmount > 100"
        text
        class="text-white"
        :disabled="currentPage === pagesAmount"
        @click.stop="currentPage = pagesAmount"
      >
        {{ pagesAmount }}
      </v-btn>
    </template>
    <v-btn
      dark
      width="24"
      height="24"
      :disabled="currentPage === pagesAmount"
      elevation="0"
      icon
      @click.stop="currentPage++"
      v-if="pagesAmount > 1"
    >
      <v-icon dark>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Number,
      required: true
    },
    pagesAmount: {
      type: Number,
      required: true
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(value) {
        this.$emit("pagechange", value);
      }
    },
    pagesList() {
      let list = [];
      if (this.currentPage <= 3) {
        list = [1, 2, 3, 4, 5];
      }
      if (this.currentPage > 3) {
        list = [
          this.currentPage - 2,
          this.currentPage - 1,
          this.currentPage,
          this.currentPage + 1,
          this.currentPage + 2
        ];
      }
      return list;
    }
  }
};
</script>

<style scoped></style>
